import React, { useEffect, useRef } from "react";

// Animated SVG waveform - 40+ pulsing bars in sine pattern
export const Waveform = ({ bars = 48, color = "#FF5B3E", className = "", height = 120, playing = true, intensity = 1 }) => {
    const refs = useRef([]);
    const rafRef = useRef(null);
    const startRef = useRef(performance.now());

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const animate = (t) => {
            const elapsed = (t - startRef.current) / 1000;
            const speed = playing ? 2.4 * intensity : 0.6;
            for (let i = 0; i < refs.current.length; i++) {
                const el = refs.current[i];
                if (!el) continue;
                const phase = i * 0.32;
                const v = Math.sin(elapsed * speed + phase) * 0.5 + 0.5;
                const v2 = Math.sin(elapsed * (speed * 1.7) + phase * 0.6) * 0.3 + 0.6;
                const h = 0.18 + v * v2 * 0.82;
                el.style.transform = `scaleY(${h})`;
            }
            rafRef.current = requestAnimationFrame(animate);
        };
        rafRef.current = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(rafRef.current);
    }, [playing, intensity]);

    const barWidth = 3;
    const gap = 4;
    const totalWidth = bars * (barWidth + gap);

    return (
        <svg
            viewBox={`0 0 ${totalWidth} ${height}`}
            className={className}
            preserveAspectRatio="none"
            aria-hidden="true"
        >
            {Array.from({ length: bars }).map((_, i) => (
                <rect
                    key={i}
                    ref={(el) => (refs.current[i] = el)}
                    x={i * (barWidth + gap)}
                    y={0}
                    width={barWidth}
                    height={height}
                    rx={barWidth / 2}
                    fill={color}
                    style={{ transformOrigin: `${i * (barWidth + gap) + barWidth / 2}px ${height / 2}px`, transform: "scaleY(0.3)" }}
                />
            ))}
        </svg>
    );
};

// Static (non-animated) waveform for placeholders
export const StaticWaveform = ({ bars = 36, color = "#0A0A0A", className = "", height = 60 }) => {
    const seed = (i) => {
        const s = Math.sin(i * 1.7) * 0.5 + 0.5;
        return Math.max(0.18, s);
    };
    const barWidth = 3, gap = 4;
    const totalWidth = bars * (barWidth + gap);
    return (
        <svg viewBox={`0 0 ${totalWidth} ${height}`} className={className} preserveAspectRatio="none" aria-hidden="true">
            {Array.from({ length: bars }).map((_, i) => {
                const h = seed(i) * height;
                return <rect key={i} x={i * (barWidth + gap)} y={(height - h) / 2} width={barWidth} height={h} rx={1.5} fill={color}/>;
            })}
        </svg>
    );
};
